import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import LoadingFallback from './components/LoadingFallback.jsx'

// Each page is its own chunk — the landing page is the only one the first
// visit needs, so Details/Verify/Complete only download once the applicant
// actually clicks through to them.
const Landing = lazy(() => import('./pages/Landing.jsx'))
const Details = lazy(() => import('./pages/Details.jsx'))
const Verify = lazy(() => import('./pages/Verify.jsx'))
const Complete = lazy(() => import('./pages/Complete.jsx'))

export default function App() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/details" element={<Details />} />
        <Route path="/verify" element={<Verify />} />
        <Route path="/complete" element={<Complete />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  )
}
